const STORAGE_KEY = 'fm_budget_v2';

export function loadBudget() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && parsed.version === 2) return parsed;
    return migrate(parsed);
  } catch {
    return null;
  }
}

export function saveBudget(state) {
  try {
    const toSave = { ...state, lastSaved: new Date().toISOString() };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
  } catch {
    // Storage full or unavailable — silent fail
  }
}

export function clearBudget() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // silent fail
  }
}

function migrate(data) {
  if (!data) return null;
  // v1 → v2: return null to force fresh start (old schema incompatible)
  return null;
}
